import common from './common'
import apimessage from './apimessage'

export default {
  ...common,
  apimessage,
}
